import React from "react";
import {
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const RecordedContactRetentionStep = ({
  formData,
  formErrors,
  handleChange,
  retentionPolicies,
}) => {
  return (
    <FormControl
      fullWidth
      error={Boolean(formErrors.retentionPolicy)}
      sx={{ mb: 2 }}
    >
      <FormLabel>Select Retention Policy</FormLabel>
      <Select
        name="retentionPolicy"
        value={formData.retentionPolicy || ""}
        onChange={handleChange}
        displayEmpty
      >
        <MenuItem value="">
          <em>Select a retention policy</em>
        </MenuItem>
        {retentionPolicies.map((policy) => (
          <MenuItem key={policy} value={policy}>
            {policy}
          </MenuItem>
        ))}
      </Select>
      {formErrors.retentionPolicy && (
        <FormHelperText>{formErrors.retentionPolicy}</FormHelperText>
      )}
    </FormControl>
  );
};

export default RecordedContactRetentionStep;
